exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wacg-wrapper .theme--light.v-subheader{color:rgba(0,0,0,.54)}#wacg-wrapper .theme--dark.v-subheader{color:hsla(0,0%,100%,.7)}#wacg-wrapper .v-subheader{align-items:center;display:flex;height:48px;font-size:.875rem;font-weight:400;padding:0 16px 0 16px}#wacg-wrapper .v-subheader--inset{margin-left:56px}", ""]);

// exports
